<template>
<div  v-loading="loading">
  <el-dialog title="短信推送详情记录" width="90%" top="60px" :visible.sync="isdshow">
    <div class="op">
  <div class="idc">
  <el-input v-model="tel" size="mini" clearable placeholder="请输入手机号"></el-input>
</div>
<div class="add">
  <el-select size="mini" clearable  v-model="isSuccess" placeholder="推送状态">
    <el-option
      v-for="item3 in isSuccessList"
      :key="item3.value"
      :label="item3.label"
      :value="item3.value">
    </el-option>
  </el-select>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="sechDetails">搜索</el-button>
</div>
  <el-table :data="gridData">
    <el-table-column label="姓名">
       <template slot-scope="scope">
       {{scope.row.personName?decrypt(scope.row.personName):''}}
       
      </template>
    </el-table-column>
    <el-table-column label="手机号">
      <template slot-scope="scope">
       {{scope.row.telephone?decrypt(scope.row.telephone):''}}
       
      </template>
    </el-table-column>
    <el-table-column label="身份证号">
      <template slot-scope="scope">
       {{scope.row.idCard?decrypt(scope.row.idCard):''}}
      </template>
    </el-table-column>
      <el-table-column label="说明" prop="bak01">
    </el-table-column>
  </el-table>
   <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals2"
      :current-page.sync="Page2"
      @current-change="current_change2"
>
    </el-pagination>
</el-dialog>
  <div class="op">
    <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
    <div class="idc">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
 <div class="add">
  <el-select size="mini" clearable  v-model="msgType" placeholder="消息类型">
    <el-option
      v-for="item3 in msgTypeList"
      :key="item3.value"
      :label="item3.label"
      :value="item3.value">
    </el-option>
  </el-select>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
</div>
<!-- <p class="contt">发送总条数：x 成功数量：x 失败数量：x</p> -->
<p> </p>
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
    <el-table-column
      prop="adminName"
      label="推送人"
      width="180">
    </el-table-column>
    <el-table-column
      prop="bak01"
      label="推送地区"
      width="150">
    </el-table-column>
     <el-table-column
      prop="content"
       width="400"
       :show-overflow-tooltip="true"
      label="推送内容">
    </el-table-column>
      <el-table-column
      prop="msgType"
       width="180"
      label="消息类型">
    </el-table-column>
    <el-table-column
      prop="counts"
       width="50"
      label="总数">
    </el-table-column>
     <el-table-column
      prop="successCount"
       width="120"
      label="成功数量">
    </el-table-column>
     <el-table-column
      prop="failCount"
       width="120"
      label="失败数量">
    </el-table-column>
    
     <el-table-column
      prop="time"
      width="180"
      label="推送时间">
    </el-table-column>
     <el-table-column
     
     label="操作">
      <template slot-scope="scope">
        <el-button
        type="primary"
          size="mini"
          icon="el-icon-edit"
          @click="handle(scope.$index, scope.row)">详情</el-button>
       
      </template>
    </el-table-column>
  </el-table>
  <div class="rrr">
  <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
    <!-- <el-button type="success" size="mini" icon="el-icon-download" @click="toExcel()">导出</el-button> -->
    </div>
  </div>
</template>

<style>
.rrr {
  display: flex;
  margin: 20px;
  height: 30px;
  justify-content: space-around;
  align-items: center;
}
.contt {
  padding: 10px;
  font-size: 15px;
  color: green;
}
.pone {
  margin: 0 !important;
}
.el-cascader-menu__wrap {
  height: 404px !important;
}
.op {
  display: flex;
  align-items: center;
}
.idc {
  width: 200px;
  margin-left: 20px;
}
.nam {
  margin-right: 20px;
}
.ywtyoe {
  width: 200px;
  margin-left: 20px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-timeline {
  padding-left: 20px;
}
.add {
  margin-left: 20px;
}
</style>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import { listtown } from "../../utils/address";
import { baseUrl2 } from "../../utils/global";
import defaultImg from "../../assets/defaultPicture.jpg";
import Candode from "../Core/candode";
import { decryptByDES, decrypt } from "../../utils/cypto";
import { formatDate } from "../../utils/datetime";
import { getType } from "../../utils/typeAuth";
import baseUrl from "../../utils/global";
import KtButton from "@/views/Core/KtButton";
export default {
  components: {
    Candode,
    KtButton
  },
  data() {
    return {
      tel: "",
      isSuccess: "",
      isSuccessList: [
        {
          value: 1000,
          label: "成功"
        },
        {
          value: 1002,
          label: "失败"
        }
      ],
      isdshow: false,
      loading: false,
      list: [],
      townList: [],
      idcard: "",
      Page: 1,
      Page2: 1,
      totals: 0,
      totals2: 0,
      gridData: [],
      tableData: [],
      msgType: "",
      msgTypeList: [
        {
          value: 1000,
          label: "认证通知"
        },
        {
          value: 1001,
          label: "到龄通知"
        },
        {
          value: 1002,
          label: "跨档通知"
        }
      ],
      townlen: 1,
      id: ""
    };
  },
  methods: {
    strReplace(msg) {
      let str = getType(msg);
      return str;
    },
    formatDate: formatDate,
    childByValue(val) {
      this.townList = val;
      // this.serchCode()
    },
    getTownlength(val) {
      this.townlen = val;
    },
    //搜索
    serch() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";

      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.serchTest(1);
    },
    serchCode() {
      let data = {
        pageNum: 1,
        pageSize: 10,
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        msgType: this.msgType,
        bak02: this.idcard ? this.Encrypt(this.idcard) : "",
        adminName:
          sessionStorage.getItem("user") == "admin"
            ? ""
            : sessionStorage.getItem("user")
      };
      this.$api.getlist
        .queryMessage(data)
        .then(res => {
          let result = res.data.list;
          this.totals = res.data.page.total_count;
          this.tableData = result;
        })
        .catch(res => {
          this.$message(JSON.stringify(res));
        });
    },
    serchTest(s) {
      Loading.service();
      console.log(this.idcard);
      var data = {
        pageNum: s,
        pageSize: 10,
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        msgType: this.msgType,
        bak02: this.idcard ? this.Encrypt(this.idcard) : "",
        adminName:
          sessionStorage.getItem("user") == "admin"
            ? ""
            : sessionStorage.getItem("user")
      };
      this.$api.getlist
        .queryMessage(data)
        .then(res => {
          if (res.code == 200) {
            let result = res.data.list;
            this.totals = res.data.page.total_count;
            this.tableData = result;
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
            this.tableData = [];
          }
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading需要异步关闭
            loadingInstance.close();
          });
        })
        .catch(err => {
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
    },
    current_change(ss) {
      this.serchTest(ss);
    },
    current_change2(s) {
      this.lookDetails(s);
    },
    sechDetails() {
      const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      console.log(isTown, 111);
      if (!isTown) {
        this.$message({
          type: "warning",
          message: "请选择县/区及以下区域进行操作"
        });
        return;
      }
      this.lookDetails(1);
      this.Page2 = 1;
    },
    torz() {},
    //查看
    handle(s, d) {
      this.isdshow = true;
      this.id = d.id;
      this.lookDetails(1);
    },
    lookDetails(s) {
      let data = {
        taskId: this.id,
        telephone: this.tel ? this.Encrypt(this.tel) : "",
        state: this.isSuccess,
        pageNum: s,
        pageSize: 10
      };
      this.$api.getlist
        .messageDetail(data)
        .then(res => {
          if (res.code == 200) {
            let result = res.data.list;
            this.totals2 = res.data.page.total_count;
            this.gridData = result;
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
            this.gridData = [];
          }
        })
        .catch(err => {});
    },
    handleDelete(g, h) {
      console.log(g);
      console.log(h);
    },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptDes(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Hex.parse(message)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },
  mounted() {
    //this.serchCode()
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/pushRecord.vue